"use strict";

var VerifyPhone = {
  $timerID: undefined,
  $phone: undefined,
  $status: undefined,
  $phoneNumber: '',
  onload: document.addEventListener('DOMContentLoaded', function () {
    VerifyPhone.init();
  }),
  init: function init() {
    this.bind();
    if (!MESSAGE_PAGE) this.inputIntlTelInput();
  },
  bind: function bind() {
    $(document).on('click', '#open-first-step-phone-verification-popup', function (event) {
      event.preventDefault();
      VerifyPhone.openFirstStep();
    }).on('click', '#open-second-step-phone-verification-popup', function (event) {
      event.preventDefault();
      VerifyPhone.$phone = $('.iti__selected-dial-code').html() + $('.inputIntlTelInput').val();
      VerifyPhone.ajax.verifyPhone();
    }).on('click', '.close-phone-verification-popup', function (event) {
      event.preventDefault();
      VerifyPhone.hidePopup();
      $('.need-fast-offer').removeClass('active');
    }).on('keypress', 'input.inputIntlTelInput', function (event) {
      if (event.which < 48 || event.which > 57) event.preventDefault();
    }).on('click', 'a.resend-verification-phone-code', function (event) {
      event.preventDefault();
      VerifyPhone.ajax.sendVerifyingCode();
    }).on('click', '#change-phone', function (event) {
      event.preventDefault();
      $(this).hide();
      $('.inputIntlTelInput').prop('disabled', false).val('');
      $('#open-second-step-phone-verification-popup').show();
    }).on('click', '#save-whatsapp-number', function (event) {
      event.preventDefault();
      VerifyPhone.ajax.saveWhatsappNumber($('.iti__selected-dial-code').html() + $('.whatsapp-number').val());
    }).on('click', '.skip-phone-popup', function (event) {
      event.preventDefault();
      VerifyPhone.ajax.skipPhonePopup();
    });
    $(document).on('input paste', 'input#phone-verification-code', function () {
      $('.popup__verification-code').find('p.error').hide();
      var value = $(this).val();
      if (value.length >= 4) VerifyPhone.ajax.verifyCode(value);
    });
  },
  openFirstStep: function openFirstStep() {
    $('.popup__verify-phone').css('display', "flex");
    $('#open-second-step-phone-verification-popup').show();
    $('.popup__verification-done').hide();
    $('.popup__verification-code').hide();
  },
  openSecondStep: function openSecondStep() {
    $('.popup__verify-phone').hide();
    $('.popup__verification-done').hide();
    $('.popup__verification-code').css('display', "flex");
    $('span#phoneNumber').html(VerifyPhone.$phone);
  },
  openThirdStep: function openThirdStep() {
    VerifyPhone.$userPhoneNumber = '';
    $('.popup__verify-phone').hide();
    $('.popup__verification-code').hide();
    $('.popup__verification-done').css('display', "flex");
    setTimeout(function () {
      var activeStep = $('div.active');
      activeStep.find('.form-step__next').click();
      activeStep.find('.form-step__submit').click();

      // $('form[data-type]').find('.submit-form').click();
    }, 1000);
    setTimeout(function () {
      $('.popup__verification-done').hide();
    }, 2000);
  },
  hidePopup: function hidePopup() {
    $('.verification-phone-popup').hide();
    VerifyPhone.$userPhoneNumber = '';
    clearTimeout(VerifyPhone.$timerID);
  },
  inputIntlTelInput: function inputIntlTelInput() {
    var phoneInputs = document.querySelectorAll(".inputIntlTelInput");
    if (phoneInputs.length > 0) {
      $.each(phoneInputs, function (key, item) {
        window.intlTelInput(item, {
          nationalMode: true,
          preferredCountries: ["de", "nl", "fr", "in", "gb", "us", "at", "ch"],
          separateDialCode: true,
          initialCountry: "auto",
          geoIpLookup: function geoIpLookup(success, failure) {
            fetch('https://ipinfo.io/json').then(function (response) {
              return response.json();
            }).then(function (resp) {
              return success(resp && resp.country ? resp.country : 'de');
            });
          }
        });
      });
      var input = document.getElementById("inputIntlTelInput");
      if (input.value.length > 0) {
        var intl = window.intlTelInputGlobals.getInstance(input);
        intl.setNumber('+' + input.value);
      }
    }
  },
  timer: function timer(duration) {
    $('.time-block__to').hide();
    $('.time-block__from').show();
    var timer = duration;
    VerifyPhone.$timerID = setInterval(function () {
      var minutes = parseInt(timer / 60, 10);
      var seconds = parseInt(timer % 60, 10);
      var phoneResendTimeCounter = $('#timer');
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      phoneResendTimeCounter.html(minutes + ":" + seconds);
      if (--timer < 0) {
        clearTimeout(VerifyPhone.$timerID);
        timer = duration;
        phoneResendTimeCounter.html('00:' + (duration + 1));
        $('.time-block__to').show();
        $('.time-block__from').hide();
      }
    }, 1000);
  },
  ajax: {
    url: AJAX_URL,
    obj: {},
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
        VerifyPhone.ajax.obj = {};
      }, 'JSON');
    },
    saveWhatsappNumber: function saveWhatsappNumber(phone) {
      this.obj.method = 'saveWhatsappNumber';
      this.obj.phone = phone;
      this.send(function () {
        $('.need-fast-offer__content').addClass('d-none');
        $('.popup__verification-done__content').removeClass('d-none');
        setTimeout(function () {
          $('.need-fast-offer').removeClass('active');
        }, 2000);
      }, function (answer) {
        Notify.dangerNotification(answer.error);
        $('.phone-popup-error').show().text(answer.error);
        setTimeout(function () {
          $('.phone-popup-error').hide();
        }, 1500);
      });
    },
    verifyPhone: function verifyPhone() {
      this.obj.method = 'verifyPhone';
      this.obj.phone = VerifyPhone.$phone;
      this.send(function () {
        VerifyPhone.ajax.sendVerifyingCode();
        VerifyPhone.openSecondStep();
      }, function (answer) {
        Notify.dangerNotification(answer.error);
        $('#phone-popup-error').text(answer.error);
      });
    },
    sendVerifyingCode: function sendVerifyingCode() {
      this.obj.method = 'sendVerifyingCode';
      this.obj.phone = VerifyPhone.$phone;
      this.send(function () {
        $('input#phone-verification-code').val('');
        VerifyPhone.timer(30);
      }, function (answer) {
        Notify.dangerNotification('Something went wrong');
      });
    },
    checkVerifyPhoneStatus: function checkVerifyPhoneStatus() {
      this.obj.method = 'checkVerifyPhoneStatus';
      this.send(function (answer) {
        VerifyPhone.$status = answer.verifyPhone;
      });
    },
    verifyCode: function verifyCode(code) {
      this.obj.method = 'verifyCode';
      this.obj.phone = VerifyPhone.$phone;
      this.obj.code = code;
      this.send(function () {
        clearTimeout(VerifyPhone.$timerID);
        VerifyPhone.openThirdStep();
        $('.inputIntlTelInput').prop('disabled', true);
        $('#change-phone').show();
        $('#open-second-step-phone-verification-popup').hide();
      }, function (answer) {
        Notify.dangerNotification(answer.text);
        $('.popup__verification-code').find('p.error').show().html(answer.text);
      });
    },
    skipPhonePopup: function skipPhonePopup() {
      this.obj.method = 'skipPhonePopup';
      this.send(function (answer) {}, function (answer) {});
    }
  }
};